export const SCHEDULED_ACTIONS_OPEN_MODAL  = "SCHEDULED_ACTIONS_OPEN_MODAL";
export const SCHEDULED_ACTIONS_REQUEST  = "SCHEDULED_ACTIONS_REQUEST";
export const SCHEDULED_ACTIONS_RESULT  = "SCHEDULED_ACTIONS_RESULT";